import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import UI from 'components/UI';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import StringUtil from "utils/StringUtil";
import codeDataStore from "common/codedata/store/CodeDataStore";
import message from "common/message/source/MessageSource";

function ContentsContainer() {

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();

	const [mode,setMode] = useState('D');
	const [modeReadOnly,setModeReadOnly] = useState(true);

	const [titleCode,setTitleCode] = useState('');
	const [titleCn,setTitleCn] = useState('');
	const [titleLocale,setTitleLocale] = useState('');


	//검색 
    async function initCall(titleCode) {
		let param = {
			"TITLE_CODE":titleCode
		};
		

		const response:any = await CommonUtil.execute({
		 	url:'adm_6521_detail',
		 	data: param
		})
       
		//전체데이터 
		if(response!=""){
			setTitleCode(response.TITLE_CODE);
			setTitleCn(response.TITLE_CN);
			setTitleLocale(response.TITLE_LOCALE);
		
			setMode('D');  //초기는 상세모드
			setModeReadOnly(true);
			//console.log(JSON.stringify(response));
			
		}
		
   
    }//검색

	//목록으로 
	const goList = (e) =>{
		history.push({
			pathname: './adm6520',  
			state: { data: receivedData }
		});
	}

	
	//수정 
	const titleUpdate = function (){
		setMode('U');  //수정모드
		setModeReadOnly(false);
	}

	//수정 저장
	async function titleSave() { 

		if(titleLocale == "" || titleCn == ""){
			await UIUtils.alert("필수값 입력해주세요.");
			return;
		}
		
		let param = {
			"TITLE_CODE": titleCode
			,"TITLE_LOCALE": titleLocale
			,"TITLE_CN": titleCn
		};

		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
			const response:any = await CommonUtil.execute({
				url:'adm_6521_titleUpdate',
				data: param
			})


			if (!response.COMMON_HEAD.ERROR) {
				await UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));

				initCall(titleCode);	
			}
		}  

	}

	
   // init 
	React.useEffect(() => {
		//넘어온 파라미터 바인딩   
		 if(receivedData != undefined){
			let titleCode = StringUtil.defaultString(receivedData.vTITLE_CODE);
			setTitleCode(titleCode);
			localStorage.setItem("titleCode", titleCode);
		
			initCall(titleCode);
		}
		
        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);		  
		 
        }
    },[])

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">시스템관리</a></li>
						<li className=""><a href="">명칭관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">명칭 상세</h1>
						<div className="tb-top">
							<div>
								<p className="tx fc-black"></p>총 <em className="fw500">1</em>건
							</div>
						</div>
						
						<div className="tb tb-narrow"> 
							<table>
								<caption></caption>
								<colgroup>
									<col width="90px" />
									<col width="500px" />
									<col width="" />
								</colgroup>
								<thead>
									<tr>
										<th>번호</th>
										<th>로케일</th>
										<th>명칭내용</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1</td>
										<td className="ta-left">
											<UIInput className={'tf tf-md w100p'} value={titleLocale} valueChanged={(value) => setTitleLocale(value)}  readOnly={modeReadOnly} />
										</td>
										<td className="ta-left">
											<UIInput className={'tf tf-md w100p'} value={titleCn} valueChanged={(value) => setTitleCn(value)}  readOnly={modeReadOnly} />
										</td>
									</tr>
																								
								</tbody>
							</table>
							
						</div>

						<div className="hz-root hz-right hz-gap5 mt10">
								<UI.If test = {mode =='U'}>
									<Button color="gray-o" size="sm" onClick={()=>setModeReadOnly(true)}>취소</Button>
									<Button color="pri-o" size="sm" onClick={titleSave}>저장</Button>
								</UI.If>
								<UI.If test = {mode =='D'}>
									<Button color="pri-o" size="sm" onClick={titleUpdate}>수정</Button>
								</UI.If>
								<Button color="gray-o" size="sm" onClick={goList}>목록</Button>
							</div>

					</main>

				</div>
		</PageContainer>
	);
}
export default ContentsContainer;